<template>
    <div class="social-feed">
        <FaceBook v-if="socialFeed === 'Facebook'" />
    </div>
</template>

<script>
import FaceBook from '@/components/SectionPanels/FaceBook.vue';

export default {
    name: 'SocialFeed',
    components: { FaceBook },
    computed: {
        socialFeed() {
            return this.$store.getters.social.activeSocialFeed;
        },
    },
};
</script>

<style lang="scss" scoped>
.social-feed {
    width: 100%;
    margin-top: 10px;
}
</style>
